import React, { useState, useEffect } from "react";
import { formatMoneda } from "../../util/varios";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTableFijo from "../useTableFijo";
import moment from "moment";

const TablaDeudaAgenteTasa = (props) => {
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const op = require("../../../public/modulos/datos");

  const [deuda, setDeuda] = useState();
  const [interes, setInteres] = useState();
  const [recargo, setRecargo] = useState();
  const [tasa, setTasa] = useState();
  const [totDeuda, setTotDeuda] = useState();

  const [records, setRecords] = useState([]);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const headCells = [
    {
      id: "anio",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-calendar-alt">
          {" "}
          FECHA
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "mes",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-calendar-week">
          {" "}
          TIPO MULTA
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "monto",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-money-bill">
          {" "}
          CONCEPTO
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "interes",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i
          style={{ textAlign: "center" }}
          className="fas fa-money-bill-wave-alt"
        >
          {" "}
          MONTO
        </i>
      ),
      textAlign: "center",
    },
  ];

  let heightTabla = 320;

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableFijo(records, headCells, filterFn, heightTabla);

  useEffect(() => {
    setRecords(props.tabdeuda);
    console.log(props.tabdeuda);
  }, [props.tabdeuda]);

  return (
    <div className="card mx-auto">
      <div className="card-body mx-auto col-md-12" style={{ height: "100%" }}>
        <div className="content mx-auto">
          <div className="row mx-auto col-md-12">
            <div className="col-md-12 mx-auto d-flex justify-content-end">
              <div className="col-sm-2 d-flex justify-content-end py-1">
                <button
                  className="btn btn-sm btn-primary px-2  rounded-circle"
                  title="Imprimir"
                >
                  <i className="fas fa-print"> </i>{" "}
                </button>
              </div>
            </div>
            <div className="col-md-12">
              <TblContainer>
                <TblHead />

                <TableBody>
                  {records &&
                    records.map((item, index) => (
                      <TableRow
                        key={item.anio + item.mes}
                        style={{ padding: "0" }}
                      >
                        <TableCell
                          style={{ fontSize: "10px", textAlign: "left" }}
                        >
                          {moment(item.fechatasa).format("YYYY-MM-DD")}
                        </TableCell>
                        <TableCell
                          style={{ fontSize: "10px", textAlign: "left" }}
                        >
                          {item.tipotasa}
                        </TableCell>
                        <TableCell
                          style={{ fontSize: "10px", textAlign: "right" }}
                        >
                          {item.concepto}
                        </TableCell>
                        <TableCell
                          style={{ fontSize: "10px", textAlign: "right" }}
                        >
                          {formatMoneda(
                            item.monto.toString().replace(".", ","),
                            ",",
                            ".",
                            2
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </TblContainer>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TablaDeudaAgenteTasa;



// WEBPACK FOOTER //
// ./src/components/tasas/deudasAgentes.js